
document.addEventListener("DOMContentLoaded", function(){
  document.querySelectorAll(".gb-accordion-header").forEach(function(header){
    header.addEventListener("click", function(){
      let parent = this.parentElement;
      parent.classList.toggle("active");
    });
  }); 
});
